import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback } from "react";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ContaReceberParcialForm, ContaReceberParcialSchema, defaultContaReceberParcialForm } from "../../../schemas/ContasReceber_cadastro/ContasReceberParcial_form";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DropDownBanco } from "../../../../../../common/components/dropdown_banco";
import { DefaultFormMoneyInput } from "../../../../../../common/components/default_form_money_input";

type props = {
    open: boolean,
    saving: boolean,
    ddlBanco: DropDown[] | [],
    contaReceberSelectedId: number | undefined,
    onClose: () => void,
    onSubmit: (form: ContaReceberParcialForm) => void,

}

export const CadastroContaReceberParcialModal = ({
    open,
    saving,
    ddlBanco,
    contaReceberSelectedId,
    onClose,
    onSubmit,

}: props) => {

    const hookForm = useForm<ContaReceberParcialForm>({
        reValidateMode: 'onSubmit',
        mode: 'onSubmit',
        defaultValues: defaultContaReceberParcialForm,
        resolver: zodResolver(ContaReceberParcialSchema),
    })

    const handleSubmit = useCallback((form: ContaReceberParcialForm) => {
        if (!saving) {
            onSubmit(form);
            hookForm.reset();
        }
    }, [saving, onSubmit, hookForm]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookForm.handleSubmit(handleSubmit)
                }

            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "60rem",
                    },
                },
            }}>

            <DialogTitle>
                Cadastrar Recebimento Parcial
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <div className="w-full">
                                <div className="grid grid-cols-2 gap-6 w-full justify-between bg-gray-100 dark:bg-gray-100  p-8">
                                    <div className="gap-6 w-full justify-between">
                                        <div className="w-[80%]  bg-white-100 pb-2">
                                            <DropDownBanco
                                                name="idBancoPagamento"
                                                label="Banco"
                                                required={false}
                                                readOnly={false}
                                                reactHookForm={hookForm}
                                            />
                                        </div>

                                        <div className="w-[60%]">
                                            <FormDatePickerInput
                                                name='dataBaixa'
                                                required={true}
                                                label='Data Recebimento'
                                                readOnly={false}
                                                reactHookForm={hookForm} />
                                        </div>

                                    </div>
                                    <div className="gap-6 w-full justify-between">
                                        <div className="w-full pb-2">
                                            <DefaultFormInput
                                                name='formaPagamento'
                                                label='Forma Recebimento'
                                                multiline={false}
                                                required={false}
                                                reactHookForm={hookForm}
                                            />
                                        </div>
                                        <div>
                                            <DefaultFormMoneyInput
                                                name='valorBaixa'
                                                label='Valor Recebido'
                                                required={true}
                                                readOnly={false}
                                                reactHookForm={hookForm}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}